// extracted by mini-css-extract-plugin
export default {"aglmd-input-group--default":"IyqaWle3U2uXIM0_hRaK"};